// NgRX
import { createReducer, on } from '@ngrx/store';
import { MaintainerUsersEffectsActions } from '@core/store/actions/maintainer.actions';

// Models
import { Maintainer } from '@core/models/maintainer.interface';



export const initialState: Maintainer = {
  users: {
    users: [ ],
    selectors: null,
    error: null
  },
};


export const maintainerReducer = createReducer(
  initialState,
  // Users
  on(MaintainerUsersEffectsActions.injectUsers, (_state, { users }) => {
    return ({ ..._state, users: { ..._state.users, users, error: null }});
  }),
  on(MaintainerUsersEffectsActions.injectUser, (_state, { updatedUser }) => {
    return ({ ..._state, users: {
      ..._state.users,
      error: null,
      users: _state.users.users.map(user => user.id === updatedUser.id ? updatedUser : user)
    }});
  }),
  on(MaintainerUsersEffectsActions.injectUserFormSelectors, (_state, { selectors }) => {
    return ({ ..._state, users: { ..._state.users, selectors, error: null }});
  }),
  on(MaintainerUsersEffectsActions.injectError, (_state, { error }) => {
    console.warn({ error });
    return ({ ..._state, users: { ..._state.users, error }});
  }),
);
